import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import PostCard from '../components/ui/PostCard';
import Messagerie from '../components/ui/Messagerie';

const PAYS_LABELS = { fr: 'France', es: 'Espagne', jp: 'Japon', dz: 'Algerie', gb: 'Royaume-Uni', be: 'Belgique', in: 'Inde', br: 'Bresil', us: 'Etats-Unis', de: 'Allemagne', it: 'Italie', ma: 'Maroc', tn: 'Tunisie', sn: 'Senegal' };

export default function Profil() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('profil');
  
  React.useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab) setActiveTab(tab);
  }, []);
  const [testimonials, setTestimonials] = useState([]);
  const [friends, setFriends] = useState({ accepted: [], pending: [], sent: [] });
  const [blockedList, setBlockedList] = useState([]);
  const [form, setForm] = useState({ ville: '', age: '', sexe: 'F', typeRecherche: 'ami', orientation: '', bio: '', tags: '', profilPublic: false });
  const [saveMsg, setSaveMsg] = useState(null);
  const [myPosts, setMyPosts] = useState([]);
  const [postText, setPostText] = useState('');
  const [postFile, setPostFile] = useState(null);
  const [postLoading, setPostLoading] = useState(false);
  const postFileRef = useRef();
  const [photoLoading, setPhotoLoading] = useState(false);
  const fileRef = useRef();

  const token = localStorage.getItem('mjtoken');

  useEffect(() => {
    if (!user) { navigate('/connexion'); return; }
    axios.get('/api/testimonials/mine', { headers: { Authorization: 'Bearer ' + token } })
      .then(res => setTestimonials(res.data)).catch(() => {});
    fetchFriends();
    fetchMyPosts();
    if (user.ville) setForm(p => ({ ...p,
      ville: user.ville || '',
      age: user.age || '',
      sexe: user.sexe || 'F',
      typeRecherche: user.typeRecherche || 'ami',
      orientation: user.orientation || '',
      bio: user.bio || '',
      tags: (user.tags || []).join(', '),
      profilPublic: user.profilPublic || false
    }));
  }, [user]);

  const fetchMyPosts = async () => {
    try {
      const res = await fetch('/api/posts/mine', { headers: { Authorization: 'Bearer ' + token } });
      const data = await res.json();
      if (Array.isArray(data)) setMyPosts(data);
    } catch {}
  };

  const handlePostSubmit = async () => {
    if (!postText.trim() && !postFile) return;
    setPostLoading(true);
    const fd = new FormData();
    if (postText) fd.append('text', postText);
    if (postFile) fd.append('image', postFile);
    const res = await fetch('/api/posts', {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token },
      body: fd
    });
    if (res.ok) {
      const newPost = await res.json();
      setMyPosts(prev => [newPost, ...prev]);
      setPostText('');
      setPostFile(null);
      if (postFileRef.current) postFileRef.current.value = '';
    }
    setPostLoading(false);
  };

  const fetchFriends = async () => {
    try {
      const res = await fetch('/api/friends/mine', { headers: { Authorization: 'Bearer ' + token } });
      const data = await res.json();
      setFriends(data);
    } catch {}
    try {
      const resB = await fetch('/api/friends/blocked-details', { headers: { Authorization: 'Bearer ' + token } });
      const dataB = await resB.json();
      if (Array.isArray(dataB)) setBlockedList(dataB);
    } catch {}
  };

  const handleSave = async () => {
    const tags = form.tags.split(',').map(t => t.trim()).filter(Boolean);
    const res = await fetch('/api/auth/profil-rencontres', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify({ ...form, tags })
    });
    if (res.ok) { setSaveMsg('Sauvegarde !'); setTimeout(() => setSaveMsg(null), 2000); }
  };

  const handlePhoto = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPhotoLoading(true);
    const fd = new FormData();
    fd.append('photo', file);
    const res = await fetch('/api/auth/upload-photo', {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token },
      body: fd
    });
    if (res.ok) { const data = await res.json(); setSaveMsg('Photo mise a jour !'); setTimeout(() => setSaveMsg(null), 2000); }
    setPhotoLoading(false);
  };

  const handleAccept = async (id) => {
    await fetch('/api/friends/accept/' + id, { method: 'PATCH', headers: { Authorization: 'Bearer ' + token } });
    fetchFriends();
    fetchMyPosts();
  };

  const handleRefuse = async (id) => {
    await fetch('/api/friends/refuse/' + id, { method: 'PATCH', headers: { Authorization: 'Bearer ' + token } });
    fetchFriends();
    fetchMyPosts();
  };

  const handleRemove = async (userId) => {
    if (!window.confirm('Retirer cet ami ?')) return;
    await fetch('/api/friends/remove/' + userId, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    fetchFriends();
    fetchMyPosts();
  };

  const handleDebloquer = async (userId) => {
    await fetch('/api/friends/unblock/' + userId, { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
    fetchFriends();
  };

  if (!user) return null;

  const sectionLabel = { scene: 'Sur scene', rencontre: 'Rencontres', etsi: 'Et si...', art: 'Art', documentaire: 'Documentaire', photos: 'Photos rares' };
  const statusLabel = { pending: { label: 'En attente', bg: '#fff3e0', color: '#c06030' }, approved: { label: 'Publie', bg: '#e8f5e9', color: '#1a6a30' }, rejected: { label: 'Refuse', bg: '#ffeaea', color: '#c03030' } };
  const initiales = (user.username || 'U').slice(0,2).toUpperCase();

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', fontFamily: 'Arial,sans-serif' }}>
      <div style={{ background: 'linear-gradient(135deg,#1a1010,#2a1518)', padding: '40px', display: 'flex', alignItems: 'center', gap: '24px' }}>
        <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => fileRef.current?.click()}>
          <div style={{ width: 80, height: 80, borderRadius: '50%', border: '3px solid #8b1a2a', overflow: 'hidden', background: '#f5eeeb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700, color: '#8b1a2a', flexShrink: 0 }}>
            {user.photo ? <img src={user.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initiales}
          </div>
          <div style={{ position: 'absolute', bottom: 0, right: 0, width: 24, height: 24, background: '#8b1a2a', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: '#fff', border: '2px solid #fff' }}>✎</div>
          <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handlePhoto} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#fff', marginBottom: 4 }}>{user.username}</div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>@{user.username} · {user.country} {user.ville ? '· ' + user.ville : ''} {user.age ? '· ' + user.age + ' ans' : ''}</div>
          {user.fanSince && <div style={{ fontSize: 12, color: '#e8a0a0', marginTop: 4 }}>Fan depuis {user.fanSince}</div>}
        </div>
        <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
          <Link to="/temoigner"><button style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Temoigner</button></Link>
          <button onClick={() => { logout(); navigate('/'); }} style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, padding: '9px 18px', fontSize: 13, cursor: 'pointer' }}>Se deconnecter</button><button onClick={async () => { if (!window.confirm('Supprimer definitivement votre compte et toutes vos donnees ? Cette action est irreversible.')) return; try { await fetch('/api/auth/account', { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } }); } catch {} logout(); navigate('/'); }} style={{ background: 'transparent', color: '#ff9b9b', border: '1px solid rgba(255,107,107,0.5)', borderRadius: 8, padding: '9px 18px', fontSize: 13, cursor: 'pointer', marginLeft: 8 }}>Supprimer mon compte</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', background: '#fff', borderBottom: '2px solid #c49090' }}>
        {[
          { n: testimonials.length, l: 'temoignages' },
          { n: testimonials.filter(t => t.status === 'approved').length, l: 'publies' },
          { n: friends.accepted?.length || 0, l: 'amis' },
          { n: friends.pending?.length || 0, l: 'demandes recues' }
        ].map((s, i) => (
          <div key={i} style={{ padding: '18px', textAlign: 'center', borderRight: i < 3 ? '1px solid #dccfc8' : 'none' }}>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 24, color: '#8b1a2a' }}>{s.n}</div>
            <div style={{ fontSize: 12, color: '#9a8080', marginTop: 3 }}>{s.l}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid #e8d0d0', background: '#fff', padding: '0 40px' }}>
        {[
          { key: 'profil', label: 'Mon profil' },
          { key: 'temoignages', label: 'Mes temoignages' },
          { key: 'amis', label: 'Mes amis', badge: friends.pending?.length },
          { key: 'actus', label: 'Mes actus' },
          { key: 'messages', label: 'Messages' }
        ].map(t => (
          <div key={t.key} onClick={() => setActiveTab(t.key)}
            style={{ padding: '14px 20px', fontSize: 13, color: activeTab === t.key ? '#8b1a2a' : '#9a8080', cursor: 'pointer', borderBottom: activeTab === t.key ? '2px solid #8b1a2a' : '2px solid transparent', fontWeight: activeTab === t.key ? 600 : 400, position: 'relative' }}>
            {t.label}
            {t.badge > 0 && <span style={{ position: 'absolute', top: 8, right: 2, background: '#8b1a2a', color: '#fff', borderRadius: '50%', width: 16, height: 16, fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>{t.badge}</span>}
          </div>
        ))}
      </div>

      <div style={{ padding: '24px 40px' }}>
        {saveMsg && <div style={{ background: '#e8f5ee', color: '#1a5a3a', padding: '10px 16px', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>{saveMsg}</div>}

        {activeTab === 'profil' && (
          <div>
            <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 20, marginBottom: 16 }}>
              <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 16 }}>Mes informations</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                {[{ label: 'Ville', key: 'ville', ph: 'Votre ville' }, { label: 'Age', key: 'age', ph: 'Votre age' }].map(f => (
                  <div key={f.key}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>{f.label}</label>
                    <input value={form[f.key]} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} placeholder={f.ph}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #c49090', fontSize: 13, boxSizing: 'border-box' }} />
                  </div>
                ))}
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Sexe</label>
                  <select value={form.sexe} onChange={e => setForm(p => ({ ...p, sexe: e.target.value }))} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #c49090', fontSize: 13 }}>
                    <option value="F">Femme</option><option value="H">Homme</option><option value="autre">Autre</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Je cherche</label>
                  <select value={form.typeRecherche} onChange={e => setForm(p => ({ ...p, typeRecherche: e.target.value }))} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #c49090', fontSize: 13 }}>
                    <option value="ami">Des amis</option><option value="amour">L'amour</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Orientation (facultatif)</label>
                  <select value={form.orientation} onChange={e => setForm(p => ({ ...p, orientation: e.target.value }))} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #c49090', fontSize: 13 }}>
                    <option value="">Non précisé</option>
                    <option value="hetero">Hétérosexuel(le)</option>
                    <option value="homo">Homosexuel(le)</option>
                    <option value="bi">Bisexuel(le)</option>
                    <option value="pan">Pansexuel(le)</option>
                    <option value="asexuel">Asexuel(le)</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>
              </div>
              <div style={{ marginTop: 12 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Bio</label>
                <textarea value={form.bio} onChange={e => setForm(p => ({ ...p, bio: e.target.value }))} rows={3} placeholder="Parlez de votre passion pour Michael..."
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #c49090', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginTop: 12 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Centres d'interet (separes par des virgules)</label>
                <input value={form.tags} onChange={e => setForm(p => ({ ...p, tags: e.target.value }))} placeholder="Ex: Thriller era, Danse, Concerts"
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #c49090', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 }}>
                <input type="checkbox" id="pub" checked={form.profilPublic} onChange={e => setForm(p => ({ ...p, profilPublic: e.target.checked }))} />
                <label htmlFor="pub" style={{ fontSize: 13, color: '#4a3030', cursor: 'pointer' }}>Visible dans Rencontres fans</label>
              </div>
              <button onClick={handleSave} style={{ marginTop: 16, background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Sauvegarder</button>
            </div>
          </div>
        )}

        {activeTab === 'temoignages' && (
          <div>
            {testimonials.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, background: '#fff', borderRadius: 12, border: '2px solid #c49090' }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>✦</div>
                <div style={{ fontSize: 14, color: '#6a5050', marginBottom: 16 }}>Vous n'avez pas encore de temoignage.</div>
                <Link to="/temoigner"><button style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Partager mon premier temoignage</button></Link>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {testimonials.map(t => {
                  const st = statusLabel[t.status] || statusLabel.pending;
                  return (
                    <div key={t._id} style={{ background: '#fff', border: '2px solid #c49090', borderRadius: 10, padding: 18 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <span style={{ fontSize: 12, padding: '3px 9px', borderRadius: 6, background: '#f5eeeb', color: '#8b1a2a', border: '1px solid #c49090', fontWeight: 600 }}>{sectionLabel[t.section] || t.section}</span>
                          <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 4, background: st.bg, color: st.color, fontWeight: 600 }}>{st.label}</span>
                        </div>
                        <span style={{ fontSize: 12, color: '#9a8080' }}>{new Date(t.createdAt).toLocaleDateString('fr-FR')}</span>
                      </div>
                      {t.eventName && <div style={{ fontSize: 12, color: '#8b1a2a', marginBottom: 6, fontWeight: 600 }}>{t.eventName}</div>}
                      <p style={{ fontSize: 13, color: '#1a1010', lineHeight: 1.6, fontStyle: 'italic', fontFamily: 'Georgia,serif', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>"{t.content}"</p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {activeTab === 'amis' && (
          <div>
            {friends.pending?.length > 0 && (
              <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 20, marginBottom: 16 }}>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 16 }}>
                  Demandes recues
                  <span style={{ fontSize: 12, background: '#f5eeeb', color: '#8b1a2a', padding: '2px 8px', borderRadius: 10, marginLeft: 8 }}>{friends.pending.length}</span>
                </div>
                {friends.pending.map(f => (
                  <div key={f.friendshipId} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, borderRadius: 8, border: '1px solid #e8d0d0', background: '#fafaf8', marginBottom: 8 }}>
                    <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#e8c0c8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: '#8b1a2a', overflow: 'hidden', flexShrink: 0 }}>
                      {f.user.photo ? <img src={f.user.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (f.user.username || 'U').slice(0,2).toUpperCase()}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1010' }}>{f.user.username}</div>
                      <div style={{ fontSize: 12, color: '#9a8080' }}>{f.user.country} {f.user.ville ? '· ' + f.user.ville : ''}</div>
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => handleAccept(f.friendshipId)} style={{ padding: '6px 14px', borderRadius: 6, border: 'none', background: '#1a6a30', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Accepter</button>
                      <button onClick={() => handleRefuse(f.friendshipId)} style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>Refuser</button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {blockedList.length > 0 && (
              <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 20, marginBottom: 16 }}>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 16 }}>
                  Membres bloqués <span style={{ fontSize: 13, color: '#9a8080' }}>({blockedList.length})</span>
                </div>
                {blockedList.map(bm => (
                  <div key={bm._id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, borderRadius: 8, border: '1px solid #e8d0d0', background: '#fafaf8', marginBottom: 8 }}>
                    <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#e8c0c8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: '#8b1a2a', overflow: 'hidden', flexShrink: 0 }}>
                      {bm.photo ? <img src={bm.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (bm.username || 'U').slice(0, 2).toUpperCase()}
                    </div>
                    <div style={{ flex: 1, fontSize: 13, fontWeight: 600, color: '#1a1010' }}>{bm.username}</div>
                    <button onClick={() => handleDebloquer(bm._id)} style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid #8b1a2a', background: '#fff', color: '#8b1a2a', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>Débloquer</button>
                  </div>
                ))}
              </div>
            )}
            <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 20 }}>
              <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 16 }}>
                Mes amis <span style={{ fontSize: 13, color: '#9a8080' }}>({friends.accepted?.length || 0})</span>
              </div>
              {friends.accepted?.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '24px 0', color: '#9a8080', fontSize: 13, fontStyle: 'italic' }}>Pas encore d'amis. Explorez les profils dans Rencontres fans !</div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
                  {friends.accepted.map(f => (
                    <div key={f.user._id} onClick={() => navigate('/membre/' + f.user.username)} style={{ border: '1px solid #e8d0d0', borderRadius: 8, padding: 12, textAlign: 'center', background: '#fafaf8', cursor: 'pointer' }}>
                      <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#e8c0c8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, color: '#8b1a2a', margin: '0 auto 6px', overflow: 'hidden' }}>
                        {f.user.photo ? <img src={f.user.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (f.user.username || 'U').slice(0,2).toUpperCase()}
                      </div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1010', marginBottom: 2 }}>{f.user.username}</div>
                      <div style={{ fontSize: 12, color: '#9a8080' }}>{f.user.country} {f.user.ville ? '· ' + f.user.ville : ''}</div>
                      <span onClick={() => handleRemove(f.user._id)} style={{ fontSize: 12, color: '#c49090', cursor: 'pointer', marginTop: 6, display: 'block' }}>Retirer</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === 'messages' && (
          <Messagerie token={token} currentUser={user} />
        )}

        {activeTab === 'actus' && (
          <div>
            <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 10, padding: 16, marginBottom: 16 }}>
              <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 12 }}>Nouvelle actu</div>
              <textarea value={postText} onChange={e => setPostText(e.target.value)} rows={3}
                placeholder="Partagez une pensee, un souvenir, une decouverte..."
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #c49090', borderRadius: 8, fontSize: 13, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'Arial,sans-serif', marginBottom: 10 }} />
              {postFile && <div style={{ fontSize: 12, color: '#8b1a2a', marginBottom: 8 }}>Photo: {postFile.name}</div>}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <button onClick={() => postFileRef.current?.click()} style={{ fontSize: 12, color: '#8b1a2a', cursor: 'pointer', background: 'none', border: 'none' }}>
                  Photo
                </button>
                <input ref={postFileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => setPostFile(e.target.files[0])} />
                <button onClick={handlePostSubmit} disabled={postLoading || (!postText.trim() && !postFile)}
                  style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: postLoading ? '#c49090' : '#8b1a2a', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                  {postLoading ? 'Publication...' : 'Publier'}
                </button>
              </div>
            </div>
            {myPosts.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px 0', color: '#9a8080', fontSize: 13, fontStyle: 'italic' }}>Aucune actu publiee.</div>
            ) : (
              myPosts.map(post => (
                <PostCard key={post._id} post={post} currentUserId={user?._id || user?.id}
                  token={token}
                  onUpdate={updated => setMyPosts(prev => prev.map(p => p._id === updated._id ? updated : p))}
                  onDelete={id => setMyPosts(prev => prev.filter(p => p._id !== id))} />
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
